export const getEnvironmentDisplayName = (env) => {
  if (!env || !env.name) return '';
  return env.alt_name ? `${env.name} (${env.alt_name})` : env.name;
};
